import { createReducer, on } from '@ngrx/store'
import { DisplayLayoutEnum } from '../../models/enums/display-layout.enum'
import * as WithPNOColleaguesActions from './with-pno-colleagues.actions'
import { LinkingWithPNOColleaguesState } from './with-pno-colleagues.state'

export const initialState: LinkingWithPNOColleaguesState = {
   displayLayout: DisplayLayoutEnum.LIST,
}

export const withPNOColleaguesReducer = createReducer(
   initialState,
   on(WithPNOColleaguesActions.setWithPNOColleaguesDisplayLayoutList, (state) => ({
      ...state,
      displayLayout: DisplayLayoutEnum.LIST,
   })),
   on(WithPNOColleaguesActions.setWithPNOColleaguesDisplayLayoutGrid, (state) => ({
      ...state,
      displayLayout: DisplayLayoutEnum.GRID,
   })),
   on(WithPNOColleaguesActions.getWithPNOColleaguesData, (state) => ({
      ...state,
      data: undefined,
      isLoading: true,
   })),
   on(WithPNOColleaguesActions.getWithPNOColleaguesDataSuccess, (state, action) => ({
      ...state,
      data: action.data,
      isLoading: false,
   })),
   on(WithPNOColleaguesActions.getWithPNOColleaguesDataFailure, (state, action) => ({
      ...state,
      data: undefined,
      isLoading: false,
   })),
   on(WithPNOColleaguesActions.resetWithPNOColleaguesState, (state) => ({
      ...state,
      displayLayout: DisplayLayoutEnum.LIST,
   }))
)
